// Phase 6 — Sales Report wrapper (static). Hosts the migrated ReportSubmenu.
import ApparelMenu from "../SubComponents/apparelMenu";
import ReportSubmenu from "../SubComponents/reportSubmenu";

const SalesReport = () => {
    return (
        <div className="mz">
            <ApparelMenu selectedKey="4" />
            <ReportSubmenu />
        </div>
    )
}

export default SalesReport;
